import {createRouter, createWebHashHistory} from 'vue-router';
import { ElNotification } from 'element-plus';
import config from "@/config"
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import tool from '@/utils/tool';
import systemRouter from './systemRouter';
import userRoutes from '@/config/route';
import {beforeEach, afterEach} from './scrollBehavior';
import { mergeGeneratedMenus } from '@/utils/generatedMenus';
import { routerjosn } from '@/utils/routerjson';

//系统路由
const routes = systemRouter



//系统特殊路由
const routes_404 = {
	path: "/:pathMatch(.*)*",
	hidden: true,
	component: () => import(/* webpackChunkName: "404" */ '@/layout/other/404'),
}
let routes_404_r = ()=>{}

const router = createRouter({
	history: createWebHashHistory(),
	routes: routes
})

// if (window.__MICRO_APP_ENVIRONMENT__) {
// 	const realBaseRoute = window.__MICRO_APP_BASE_ROUTE__

// 	router.beforeEach(() => {
// 		if (typeof window.history.state?.current === 'string') {
// 		window.history.state.current = window.history.state.current.replace(new RegExp(realBaseRoute, 'g'), '')
// 		}
// 	})

// 	router.afterEach(() => {
// 		if (typeof window.history.state === 'object') {
// 		window.history.state.current = realBaseRoute +  (window.history.state.current || '')
// 		}
// 	})
// }

//设置标题
document.title = config.APP_NAME

//判断是否已加载过动态/静态路由
var isGetRouter = false;

router.beforeEach(async (to, from, next) => {

	NProgress.start()
	//动态标题
	document.title = to.meta.title ? `${to.meta.title} - ${config.APP_NAME}` : `${config.APP_NAME}`

	let token = tool.cookie.get("MNMALL_TOKEN");
	
	if(to.path === "/login"){
		//已持有有效 token（含 24 小时免登录场景）时直接进入首页，
		//避免进入登录页触发 created() 清除 token 导致免登录失效
		if(token){
			next({ path: '/' });
			return false;
		}
		//删除路由(替换当前layout路由)
		router.addRoute(routes[0])
		//删除路由(404)
		routes_404_r()
		isGetRouter = false;
		next();
		return false;
	}

	if(routes.findIndex(r => r.path === to.path) >= 0){
		next();
		return false;
	}

	if(!token){
		next({
			path: '/login'
		});
		return false;
	}

	//整页路由处理
	if(to.meta.fullpage){
		to.matched = [to.matched[to.matched.length-1]]
	}
	//加载动态/静态路由
	if(!isGetRouter){
		//菜单数据源：优先使用登录时按权限写入的过滤菜单（子账号动态菜单），
		//不存在时（token 直入/历史会话残留）回落全量硬编码并初始化写入；
		//注意：存在过滤菜单时不可回写，否则会把过滤结果替换为全量
		let storedMenu = tool.data.get('MNMALL_MENU')
		let apiMenu
		if (storedMenu && storedMenu.length) {
			apiMenu = mergeGeneratedMenus(storedMenu)
		} else {
			apiMenu = mergeGeneratedMenus(routerjosn.content)
			tool.data.set('MNMALL_MENU', apiMenu)
		}
		let userInfo = tool.data.get("MNMALL_USER_INFO")
		let userMenu = treeFilter(userRoutes, node => {
			return node.meta.role ? node.meta.role.filter(item=>userInfo.role.indexOf(item)>-1).length > 0 : true
		})
		let menu = [...userMenu, ...apiMenu]
		var menuRouter = filterAsyncRouter(menu)
		menuRouter = flatAsyncRoutes(menuRouter)
		menuRouter.forEach(item => {
			router.addRoute("layout", item)
		})
		if(!window.__MICRO_APP_ENVIRONMENT__){
			routes_404_r = router.addRoute(routes_404)
		}
		if (to.matched.length == 0) {
			router.push(to.fullPath);
		}
		isGetRouter = true;
	}
	beforeEach(to, from)
	next();
});

router.afterEach((to, from) => {
	afterEach(to, from)
	NProgress.done()
});

router.onError((error) => {
	NProgress.done();
	ElNotification.error({
		title: '路由错误',
		message: error.message
	});
});

//入侵追加自定义方法、对象
router.sc_getMenu = () => {
	//菜单数据源与路由守卫保持一致：优先使用登录时按权限写入的过滤菜单
	//（左侧导航/标签页均取自此方法），回落全量硬编码（token 直入等未过滤场景）
	var storedMenu = tool.data.get('MNMALL_MENU')
	var apiMenu = (storedMenu && storedMenu.length)
		? mergeGeneratedMenus(storedMenu)
		: mergeGeneratedMenus(routerjosn.content)
	let userInfo = tool.data.get("MNMALL_USER_INFO")
	let userMenu = treeFilter(userRoutes, node => {
		return node.meta.role ? node.meta.role.filter(item=>userInfo.role.indexOf(item)>-1).length > 0 : true
	})
	var menu = [...userMenu, ...apiMenu]
	return menu
}

//转换
function filterAsyncRouter(routerMap) {
	const accessedRouters = []
	routerMap.forEach(item => {
		item.meta = item.meta?item.meta:{};
		//处理外部链接特殊路由
		if(item.meta.type=='iframe'){
			item.meta.url = item.path;
			item.path = `/i/${item.name}`;
		}
		//MAP转路由对象
		var route = {
			path: item.path,
			name: item.name,
			meta: item.meta,
			redirect: item.redirect,
			children: item.children ? filterAsyncRouter(item.children) : null,
			component: loadComponent(item.component)
		}
		accessedRouters.push(route)
	})
	return accessedRouters
}
function loadComponent(component){
	if(component){
		return () => import(/* webpackChunkName: "[request]" */ `@/views/${component}`)
	}else{
		return () => import(`@/layout/other/empty`)
	}

}

//路由扁平化
function flatAsyncRoutes(routes, breadcrumb=[]) {
	let res = []
	routes.forEach(route => {
		const tmp = {...route}
        if (tmp.children) {
            let childrenBreadcrumb = [...breadcrumb]
            childrenBreadcrumb.push(route)
            let tmpRoute = { ...route }
            tmpRoute.meta.breadcrumb = childrenBreadcrumb
            delete tmpRoute.children
            res.push(tmpRoute)
            let childrenRoutes = flatAsyncRoutes(tmp.children, childrenBreadcrumb)
            childrenRoutes.map(item => {
                res.push(item)
            })
        } else {
            let tmpBreadcrumb = [...breadcrumb]
            tmpBreadcrumb.push(tmp)
            tmp.meta.breadcrumb = tmpBreadcrumb
            res.push(tmp)
        }
    })
    return res
}

//过滤树
function treeFilter(tree, func) {
	return tree.map(node => ({ ...node })).filter(node => {
		node.children = node.children && treeFilter(node.children, func)
		return func(node) || (node.children && node.children.length)
	})
}

export default router
